export default "__VITE_ASSET__Cmt4a2eP__"